export enum DossierItemType {
  Attachment = 0,
  Folder = 1,
  Link = 2,
}
